module.exports = __webpack_public_path__ + "img/magnify.df31adb5.svg";